











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const RESOLUTION_DELTA = 1.8;
const WIDTH = {
  list: 177,
  tile: 280
};
const HEIGHT = {
  list: 30,
  tile: 158
};

@Component
export default class ResponsiveImage extends Vue {
  @Prop() src!: string;

  @Prop() cardView!: string;

  $refs!: { wrapper: Element };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  originalRatio: any = null;

  isFileLoaded = false;

  width = 0;

  height = 0;

  get isSmallImage() {
    return this.originalRatio
      ? this.originalRatio.width <= this.width && this.originalRatio.height <= this.height
      : false;
  }

  get resolution() {
    return this.originalRatio && this.originalRatio.width / this.originalRatio.height;
  }

  get isEnoughResolution() {
    return this.resolution >= RESOLUTION_DELTA;
  }

  get imageStyles() {
    if (!this.originalRatio || this.isSmallImage) {
      return {};
    }

    const prop = this.isEnoughResolution ? 'width' : 'height';

    return {
      [prop]: '100%'
    };
  }

  mounted() {
    const { clientWidth, clientHeight } = this.$el.parentElement as Element;
    this.width = clientWidth;
    this.height = clientHeight;
  }

  @Watch('cardView')
  onCardViewChange(val: 'tile' | 'list') {
    this.width = WIDTH[val];
    this.height = HEIGHT[val];
  }

  @Watch('src', { immediate: true })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSrcChange(val: any) {
    this.isFileLoaded = false;
    const img = new Image();
    this.$emit('cover:loading', true);

    img.onload = () => {
      this.isFileLoaded = true;
      this.$emit('cover:loading', false);
      const { naturalWidth: width, naturalHeight: height } = img;

      this.originalRatio = {
        width,
        height
      };
    };

    img.src = val;
  }
}
